export default __webpack_public_path__ + "static/media/carrinho.2fd18b9f.png";